







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MerchantConfig } from '@/models/config/merchantConfig';
import AuthPanel from '../auth/AuthPanel.vue';
import i18n from '@/i18n';

@Component({
  components: {
    'ck-auth-panel': AuthPanel,
  },
})
export default class MobileAppRegistrationForm extends Vue {
  @Prop() merchantConfig!: MerchantConfig;

  public get getCurrentLanguage(): string {
    return i18n.locale ?? 'en';
  }
}
